import { GRADIENT_MODES } from "@/constants/gradientModes";

export function getPipePartsOptions(hasRemainingLife, translate, converter) {
  const localePath = "pipe_parts.details.map_select";
  const gradientArr = [
    {
      value: GRADIENT_MODES.DEGRADATION_LEVEL,
      title: translate(`${localePath}.degradation_level`),
    },
    {
      value: GRADIENT_MODES.MATERIAL,
      title: translate(`${localePath}.inspection_results.list.material`),
    },
    {
      value: GRADIENT_MODES.QUALITY,
      title: translate(`${localePath}.inspection_results.list.quality`),
    },
    {
      value: GRADIENT_MODES.QUALITY_ANOMALY,
      title: translate(`${localePath}.inspection_results.list.quality_anomaly`),
    },
    {
      value: GRADIENT_MODES.CORROSION_PRODUCT_PERC,
      title: translate(`${localePath}.inspection_results.list.corrosion_product_perc`),
    },
    {
      value: GRADIENT_MODES.REMAINING_MEAN,
      title:
        translate(`${localePath}.inspection_results.list.remaining_mean`) +
        ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.REMAINING_MIN,
      title:
        translate(`${localePath}.inspection_results.list.remaining_min`) +
        ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.REMAINING_MAX,
      title:
        translate(`${localePath}.inspection_results.list.remaining_max`) +
        ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.REMAINING_STD,
      title:
        translate(`${localePath}.inspection_results.list.remaining_std`) +
        ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.DEGRADATED_TOTAL_MEAN,
      title:
        translate(
          `${localePath}.inspection_results.list.degradated_total_mean`
        ) + ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.DEGRADATED_TOTAL_MIN,
      title:
        translate(
          `${localePath}.inspection_results.list.degradated_total_min`
        ) + ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.DEGRADATED_TOTAL_MAX,
      title:
        translate(
          `${localePath}.inspection_results.list.degradated_total_max`
        ) + ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.DEGRADATED_TOTAL_STD,
      title:
        translate(
          `${localePath}.inspection_results.list.degradated_total_std`
        ) + ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.OVALITY_MEAN,
      title: translate(`${localePath}.inspection_results.list.ovality_mean`),
    },
    {
      value: GRADIENT_MODES.OVALITY_MAX,
      title: translate(`${localePath}.inspection_results.list.ovality_max`),
    },
    {
      value: GRADIENT_MODES.HORIZONTAL_OUT_OF_STRAIGHT,
      title:
        translate(
          `${localePath}.inspection_results.list.horizontal_out_of_straight`
        ) + ` (${converter.getAbbr("m")})`,
    },
    {
      value: GRADIENT_MODES.VERTICAL_OUT_OF_STRAIGHT,
      title:
        translate(
          `${localePath}.inspection_results.list.vertical_out_of_straight`
        ) + ` (${converter.getAbbr("m")})`,
    },
    {
      value: GRADIENT_MODES.DIAMETER_CLASS,
      title:
        translate(`${localePath}.inspection_results.list.diameter_class`) +
        ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.WALL_THICKNESS_ORIGINAL,
      title:
        translate(
          `${localePath}.inspection_results.list.wall_thickness_original`
        ) + ` (${converter.getAbbr("mm")})`,
    },
    {
      value: GRADIENT_MODES.WIRE_BREAKS,
      title:
        translate(
          `${localePath}.inspection_results.list.wire_breaks`
        ),
    },
  ];

  if (hasRemainingLife) {
    gradientArr.unshift(
      {
        value: GRADIENT_MODES.REMAINING_LIFE_GROUP,
        title: translate(`${localePath}.remaining_life_group`),
      },
      {
        value: GRADIENT_MODES.SOIL_TYPE,
        title: translate(
          `${localePath}.remaining_life_calculation.list.soil_type`
        ),
      },
      {
        value: GRADIENT_MODES.ROAD_TYPE,
        title: translate(
          `${localePath}.remaining_life_calculation.list.road_type`
        ),
      },
      {
        value: GRADIENT_MODES.ROAD_DISTANCE,
        title:
          translate(
            `${localePath}.remaining_life_calculation.list.road_distance`
          ) + ` (${converter.getAbbr("m")})`,
      },
      {
        value: GRADIENT_MODES.DEGRADATION_RATE,
        title: translate(
          `${localePath}.remaining_life_calculation.list.degradation_rate`
        ),
      },
      {
        value: GRADIENT_MODES.GROUND_WATER_LEVEL,
        title:
          translate(
            `${localePath}.remaining_life_calculation.list.ground_water_level`
          ) + ` (${converter.getAbbr("m")})`,
      }
    );
  }

  return gradientArr;
}
